var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "light-theme simple-pagination",
        attrs: { id: "pagination" },
      },
      [
        _c("ul", [
          _c("li", { staticClass: "disabled" }, [
            _c("span", { staticClass: "current prev" }, [_vm._v(" ")]),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "active" }, [
            _c("span", { staticClass: "current" }, [_vm._v("1")]),
          ]),
          _vm._v(" "),
          _c("li", [_c("span", [_vm._v("2")])]),
          _vm._v(" "),
          _c("li", [_c("span", [_vm._v("3")])]),
          _vm._v(" "),
          _c("li", [_c("span", [_vm._v("4")])]),
          _vm._v(" "),
          _c("li", [_c("span", [_vm._v("5")])]),
          _vm._v(" "),
          _c("li", [_c("span", [_vm._v("6")])]),
          _vm._v(" "),
          _c("li", { staticClass: "disabled" }, [
            _c("span", { staticClass: "current next" }, [_vm._v(" ")]),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }